var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center position-ref full-height"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title m-b-md"},[_vm._v("Welcome Guest")]),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":"/user"}},[_vm._v("User")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }